import { useQuery } from "@tanstack/react-query";
import { Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { getPrivateLink } from "../../../../../service/api";

function DocumentShowModal({ privateLinkShow, setPrivateLinkShow }) {
  const [imageLink, setImageLink] = useState(null);

  const privateLinkQuery = useQuery(["privateLink", privateLinkShow[1]], () =>
    getPrivateLink(privateLinkShow[1])
  );

  useEffect(() => {
    if (privateLinkQuery?.data) setImageLink(privateLinkQuery?.data);
  }, [privateLinkQuery?.data]);


  return (
    <Modal
      open={privateLinkShow[0]}
      footer={null}
      onCancel={() => {
        setPrivateLinkShow(false);
        setImageLink(null);
      }}
    >
      {imageLink ? (
        <img alt="example" style={{ width: "100%" }} src={imageLink} />
      ) : (
        <div className="flex font-body gap-2 w-full h-full">
          <Spin />
          <p>در حال دریافت فایل، لطفا منتظر بمانید</p>
        </div>
      )}
    </Modal>
  );
}

export default DocumentShowModal;
